// Region-specific pricing for Yogarambh Wellness.
// Three regions: IN (India, ₹), HK (Hong Kong, HK$), ROW (Rest of World, US$).
// All prices are DUMMY values — edit freely. Each region has the same four
// plans: Single Class, Monthly, Batch and 1-on-1.

export const regions = {
  IN: { code: "IN", label: "India", flag: "🇮🇳", currency: "₹" },
  HK: { code: "HK", label: "Hong Kong", flag: "🇭🇰", currency: "HK$" },
  ROW: { code: "ROW", label: "Rest of World", flag: "🌏", currency: "US$" },
};

export const regionOrder = ["IN", "HK", "ROW"];

// plan keys are shared across regions; values are per-region.
export const pricing = {
  IN: {
    currency: "₹",
    plans: [
      {
        key: "single",
        name: "Single Class",
        price: "500",
        unit: "/ class",
        tagline: "Try a session",
        featured: false,
        features: [
          "1 live yoga class",
          "Any group program",
          "Online or in-person",
          "No commitment",
        ],
      },
      {
        key: "monthly",
        name: "Monthly",
        price: "4,000",
        unit: "/ month",
        tagline: "Most popular",
        featured: true,
        features: [
          "12 group classes / month",
          "All group programs",
          "Practice guidance & tips",
          "Priority scheduling",
        ],
      },
      {
        key: "batch",
        name: "Batch (Quarterly)",
        price: "10,500",
        unit: "/ 3 months",
        tagline: "Best value",
        featured: false,
        features: [
          "Fixed weekly batch",
          "Save vs monthly",
          "Steady routine",
          "Progress tracking",
        ],
      },
      {
        key: "private",
        name: "1-on-1 Personal",
        price: "1,500",
        unit: "/ session",
        tagline: "Fully personalised",
        featured: false,
        features: [
          "Private session with Suman",
          "Tailored to your goals",
          "Flexible timing",
          "Online or in-person",
        ],
      },
    ],
  },

  HK: {
    currency: "HK$",
    plans: [
      {
        key: "single",
        name: "Single Class",
        price: "180",
        unit: "/ class",
        tagline: "Try a session",
        featured: false,
        features: [
          "1 live yoga class",
          "Any group program",
          "Online or in-person",
          "No commitment",
        ],
      },
      {
        key: "monthly",
        name: "Monthly",
        price: "1,500",
        unit: "/ month",
        tagline: "Most popular",
        featured: true,
        features: [
          "12 group classes / month",
          "All group programs",
          "Practice guidance & tips",
          "Priority scheduling",
        ],
      },
      {
        key: "batch",
        name: "Batch (Quarterly)",
        price: "4,000",
        unit: "/ 3 months",
        tagline: "Best value",
        featured: false,
        features: [
          "Fixed weekly batch",
          "Save vs monthly",
          "Steady routine",
          "Progress tracking",
        ],
      },
      {
        key: "private",
        name: "1-on-1 Personal",
        price: "550",
        unit: "/ session",
        tagline: "Fully personalised",
        featured: false,
        features: [
          "Private session with Suman",
          "Tailored to your goals",
          "Flexible timing",
          "Online or in-person",
        ],
      },
    ],
  },

  ROW: {
    currency: "US$",
    plans: [
      {
        key: "single",
        name: "Single Class",
        price: "22",
        unit: "/ class",
        tagline: "Try a session",
        featured: false,
        features: [
          "1 live yoga class",
          "Any group program",
          "Online sessions",
          "No commitment",
        ],
      },
      {
        key: "monthly",
        name: "Monthly",
        price: "190",
        unit: "/ month",
        tagline: "Most popular",
        featured: true,
        features: [
          "12 group classes / month",
          "All group programs",
          "Practice guidance & tips",
          "Priority scheduling",
        ],
      },
      {
        key: "batch",
        name: "Batch (Quarterly)",
        price: "500",
        unit: "/ 3 months",
        tagline: "Best value",
        featured: false,
        features: [
          "Fixed weekly batch",
          "Save vs monthly",
          "Steady routine",
          "Progress tracking",
        ],
      },
      {
        key: "private",
        name: "1-on-1 Personal",
        price: "70",
        unit: "/ session",
        tagline: "Fully personalised",
        featured: false,
        features: [
          "Private session with Suman",
          "Tailored to your goals",
          "Flexible timing",
          "Online sessions",
        ],
      },
    ],
  },
};

export default pricing;
